import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { Box, Link } from "@mui/material";
import { useAppSelector } from "@/store/hooks";
import { TypographyWithCopy } from "@/components/common/TypographyWithCopy";
import { resourceDetailsTargetResourceSelector } from "@/store/resource-details/selectors/target-resource/resourceDetailsTargetResourceSelector";
import {
  commitmentIdForDrawerSearchParam,
  providerIdForDrawerSearchParam,
} from "@/components/pages/commtiments/utilization-and-coverage/utils/hooks/useCommitmentDrawerOpener.hook";

export const ResourceDetailsCoverageTabDataGridCommitmentIdCellRenderer: FC<
  ICellRendererParams
> = ({ value, data }) => {
  const resource = useAppSelector(resourceDetailsTargetResourceSelector);
  const orgId = resource?.providerOrgId;
  const provider = resource?.provider;
  const commitmentId = data?.commitment?.id;

  const typography = (
    <TypographyWithCopy
      value={value}
      fontSize="inherit"
      sx={{ cursor: "pointer" }}
    />
  );

  if (!provider || !orgId || !commitmentId) {
    return typography;
  }

  return (
    <Box
      target="_blank"
      component={Link}
      href={`/commitments/${provider}/${orgId}?active=savings_plan&${providerIdForDrawerSearchParam}=${value}&${commitmentIdForDrawerSearchParam}=${commitmentId}`}
    >
      {typography}
    </Box>
  );
};
